import { createStore } from 'vuex'
import game from './modules/game/game-store'

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    game
  }
})
